import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { getUploadFileFullPath } from '../../../util/utilFunction';

export default function TitlebarImageList({imageList}) { 
  return (
    <ImageList title="deneme" >
  
      {imageList.map((item) => (
        <ImageListItem key={item.id}>
          <img
            src={`${ getUploadFileFullPath(item)}?w=248&fit=crop&auto=format`}
            srcSet={`${getUploadFileFullPath(item)}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={item.docTypeTitle}
            loading="lazy"
          />
          <ImageListItemBar
            title={item.docTypeTitle}
            subtitle={item.copyrightStatus===1 ? "Telifi Var" : "Telifi Yok"}
            actionIcon={
              <IconButton
              onClick={()=>window.open(item.source, "_blank")}
                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                aria-label={`info about ${item.docTypeTitle}`}
              >
                <InfoIcon />
              </IconButton>
            }
          />
        </ImageListItem>
      ))}
    </ImageList>
  );
}
